import templateUrl from "emun.auth/register-retailer-fieldset.htm";
import basicController from "servicestack/basic.controller.properties";

export class RegisterRetailerFeildsetController {
  constructor() {
    basicController(this);
  }

  copyBillingToShipping() {
    const $ctrl = this;
    Object.assign($ctrl.request.shipping, $ctrl.request.billing);
  }
}

export default {
  templateUrl,
  bindings: {
    request: "<ngModel",
    bus: "<?"
  },
  controller: RegisterRetailerFeildsetController
};
